module.exports = __webpack_public_path__ + "static/media/Tablou2.5827543e.webp";